export default __webpack_public_path__ + "static/din_pellets-81420e8e778dfd187f02fd503348359d.svg";